export const CREDIT_LIMIT_MODEL = {
    ENTIRE: 'ENTIRE',
    MONTHLY: 'MONTHLY',
    CCB: 'CCB',
};
